import { render, staticRenderFns } from "./gateway.vue?vue&type=template&id=f51d95b2&scoped=true&"
import script from "./gateway.vue?vue&type=script&lang=js&"
export * from "./gateway.vue?vue&type=script&lang=js&"
import style0 from "./gateway.vue?vue&type=style&index=0&id=f51d95b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51d95b2",
  null
  
)

export default component.exports